import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { IntegerInput } from '../../../../Input'
import {
  CONTRACT_FORM_DURATION_MAX,
  CONTRACT_FORM_DURATION_MIN,
  CONTRACT_FORM_FIELD_NAME_DURATION,
} from '../../../Contract.constants'

import * as styles from './DurationField.module.css'

function DurationField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const [isEditing, setEditing] = useState(false)

  function getDurationDisplayValue(value) {
    return !isEditing && value
      ? `${value} ${t('ContractTable.DurationMonthsKey')}`
      : (value ?? EMPTY_STRING)
  }

  function handleBlur() {
    setEditing(false)
  }

  function handleFocus() {
    setEditing(true)
  }

  return (
    <FormikField
      {...props}
      ClearButton={null}
      Component={IntegerInput}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Contract.DurationLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      max={CONTRACT_FORM_DURATION_MAX}
      min={CONTRACT_FORM_DURATION_MIN}
      name={CONTRACT_FORM_FIELD_NAME_DURATION}
      placeholder={t('Contract.DurationPlaceholderKey')}
      transformValue={getDurationDisplayValue}
      wrapperClassName={styles.input}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  )
}

export default DurationField
